var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.enrollments),function(enrollment){return _c('EnrollmentCard',{key:enrollment.id,attrs:{"enrollment":enrollment},on:{"status-clicked":_vm.onStatusClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }